module.exports = require('./helpers/bundle-url').getBundleURL('8fOTM') + "logo.7718c6df.svg";